// extracted by mini-css-extract-plugin
export default {"section":"Offer_section__88eB5","stage":"Offer_stage__Ww5qJ","title":"Offer_title__sty1f","text":"Offer_text__wG5TU"};